import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from './api';

type GetUserAemInfoResponse = {
  email: string | undefined;
  updatedAt: string;
};

export type EditAemCredentialsPayload = {
  email: string;
  apiKey: string;
};

export type EditAemCredentialsResponse = {
  message: string;
};

const BASE_URL = `${import.meta.env.VITE_AUTOMATION_API_URL}/automation`;

export const apiAem = createApi({
  reducerPath: 'apiAem',
  baseQuery: (...args) => baseQueryWithReAuth(...args, { baseUrl: BASE_URL }),
  tagTypes: ['aem-user'],
  endpoints: (build) => ({
    getUserAemInfo: build.query<GetUserAemInfoResponse, void>({
      query: () => ({
        url: `/aem-user`,
        method: 'GET'
      }),
      providesTags: ['aem-user']
    }),
    editAemCredentials: build.mutation<EditAemCredentialsResponse, EditAemCredentialsPayload>({
      query: (body) => ({
        url: '/aem-user',
        method: 'PUT',
        body
      }),
      invalidatesTags: ['aem-user']
    })
  })
});

export const { useGetUserAemInfoQuery, useEditAemCredentialsMutation } = apiAem;
